import {
  PlannerItemHeroIconSize,
  ShadowPulse
} from '@cont/PlannerV2/PlannerCards/ClassCard/PlayIcon';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import QuizHeroCircle from '@icon/Planner/QuizHeroCircle';

const StyledIcon = styled(QuizHeroCircle)`
  border-radius: 50%;
  ${({ $isLive }) =>
    $isLive &&
    css`
      animation: ${ShadowPulse} 1s infinite;
    `}
`;

const QuizHeroIcon = ({ color, isLive }) => (
  <StyledIcon
    size={PlannerItemHeroIconSize}
    className="play-icon"
    color={color}
    $isLive={isLive}
  />
);

export default QuizHeroIcon;
